import React from 'react';
import { FileText, ShieldCheck } from 'lucide-react';

const sections = [
  {
    title: 'Uso del sitio',
    body: 'El uso de este sitio implica la aceptación de estos términos y condiciones. La información publicada tiene fines informativos sobre los servicios de PrestaNet y puede actualizarse sin previo aviso.'
  },
  {
    title: 'Servicios financieros',
    body: 'La disponibilidad, aprobacion, monto, plazo y condiciones de cualquier crédito estan sujetas a evaluación, validación de información, capacidad de pago y politicas internas vigentes. La información del sitio no constituye una oferta definitiva ni garantiza la autorización de un préstamo.'
  },
  {
    title: 'Informacion del usuario',
    body: 'El usuario se obliga a proporcionar información verdadera, completa y actualizada cuando solicite contacto, asesoria o una evaluación de crédito. PrestaNet podra solicitar documentos o datos adicionales para validar una solicitud.'
  },
  {
    title: 'Propiedad intelectual',
    body: 'Los textos, imágenes, logotipos, marcas, diseños y demas elementos de este sitio pertenecen a su titular o se utilizan con autorización. Queda prohibida su reproducción, distribución o modificación sin consentimiento previo y por escrito.'
  },
  {
    title: 'Responsabilidad',
    body: 'PrestaNet procura mantener la información del sitio actualizada y disponible; sin embargo, no garantiza que el sitio funcione sin interrupciones, errores tecnicos o fallas ajenas a su control.'
  },
  {
    title: 'Modificaciones',
    body: 'El titular del sitio podra modificar estos términos y condiciones en cualquier momento. Las modificaciónes surtiran efecto desde su publicación en esta pagina.'
  }
];

export const Terms = () => {
  return (
    <main className="min-h-screen bg-slate-50 pt-28">
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 px-4 py-16 text-white">
        <div className="container mx-auto max-w-5xl">
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-400 text-slate-950 shadow-lg">
            <FileText size={28} />
          </div>
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-amber-300">
            Informacion legal
          </p>
          <h1 className="text-4xl font-bold leading-tight md:text-6xl">
            Terminos y condiciones
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-slate-200">
            Consulta las reglas generales de uso del sitio web y la información del titular que opera PrestaNet.
          </p>
        </div>
      </section>

      <section className="px-4 py-14">
        <div className="container mx-auto max-w-5xl">
          <div className="mb-8 rounded-lg border border-amber-200 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-3 text-slate-900">
              <ShieldCheck className="text-emerald-600" size={24} />
              <h2 className="text-2xl font-bold">Aviso legal / Titular del sitio</h2>
            </div>
            <p className="text-slate-700 leading-relaxed">
              Este sitio web (<strong>prestanet.com.mx</strong>) es operado por{' '}
              <strong>LUIS GUSTAVO VACA DINGFELDER</strong> (RFC:{' '}
              <strong>VADL730823B69</strong>).
            </p>
          </div>

          <div className="grid gap-5">
            {sections.map((section) => (
              <article key={section.title} className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
                <h2 className="mb-3 text-xl font-bold text-slate-900">{section.title}</h2>
                <p className="leading-relaxed text-slate-600">{section.body}</p>
              </article>
            ))}
          </div>

          <div className="mt-8 rounded-lg bg-slate-900 p-6 text-slate-200">
            <h2 className="mb-3 text-xl font-bold text-white">Contacto</h2>
            <p className="leading-relaxed">
              Para dudas relacionadas con estos términos, puedes escribir a{' '}
              <a className="font-semibold text-amber-300 hover:text-amber-200" href="mailto:quierocrédito@prestanet.com.mx">
                quierocrédito@prestanet.com.mx
              </a>.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Terms;
